import { apiClient } from './api';
import type { CommissionLedger, CommissionBalance, CommissionSummary } from '../types/commission';

export const commissionService = {
  // Get commissions by enrollment
  getCommissionsByEnrollment: async (enrollmentId: string): Promise<CommissionLedger[]> => {
    const response = await apiClient.get<CommissionLedger[]>(`/commissions/enrollment/${enrollmentId}`);
    return response.data as CommissionLedger[];
  },

  // Get commissions by recipient
  getCommissionsByRecipient: async (recipientId: string, status?: string): Promise<CommissionLedger[]> => {
    const params = status ? `?status=${status}` : '';
    const response = await apiClient.get<CommissionLedger[]>(`/commissions/recipient/${recipientId}${params}`);
    return response.data as CommissionLedger[];
  },

  // Get balance for a recipient
  getBalance: async (recipientId: string): Promise<CommissionBalance> => {
    const response = await apiClient.get<CommissionBalance>(`/commissions/recipient/${recipientId}/balance`);
    return response.data as CommissionBalance;
  },

  // Process pending commissions (admin endpoint)
  processPendingCommissions: async (): Promise<{ processedCount: number }> => {
    const response = await apiClient.post<{ processedCount: number }>('/commissions/process');
    return response.data as { processedCount: number };
  },

  // Cancel commissions for an enrollment (refund)
  cancelCommission: async (enrollmentId: string): Promise<void> => {
    await apiClient.post(`/commissions/enrollment/${enrollmentId}/cancel`);
  },

  // Get my commissions (current user) - uses recipient ID from auth context
  getMyCommissions: async (recipientId: string, status?: string): Promise<CommissionLedger[]> => {
    const params = status ? `?status=${status}` : '';
    const response = await apiClient.get<CommissionLedger[]>(`/commissions/recipient/${recipientId}${params}`);
    return response.data as CommissionLedger[];
  },

  // Get my balance (current user) - uses recipient ID from auth context
  getMyBalance: async (recipientId: string): Promise<CommissionBalance> => {
    const response = await apiClient.get<CommissionBalance>(`/commissions/recipient/${recipientId}/balance`);
    return response.data as CommissionBalance;
  },

  // Get commission summary for dashboard - uses balance endpoint
  getCommissionSummary: async (recipientId: string): Promise<CommissionSummary> => {
    const response = await apiClient.get<CommissionSummary>(`/commissions/recipient/${recipientId}/balance`);
    return response.data as CommissionSummary;
  },
};
